import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import courselist from '../../api/courselist';
import {
  CATALOGS_GET,
  COURSE_CATEGORIES_GET,
  COURSE_LIST_GET,
  EVENT_LIST_GET,
  FFOO_GET,
  GLOBAL_COURSE_CATEGORIES_GET,
  GLOBAL_COURSE_LIST_EXPORT,
  GLOBAL_COURSE_LIST_GET,
  LEVELS_GET,
  MODULE_LIST_GET,
} from '../actions/courselist';
import { errorHandling } from '../../../utils/errors';

function* courselistGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      is_module: false,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getCoursesList,
      completeFilters
    );
    yield put({
      type: COURSE_LIST_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > courselistGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courselistGetWatch() {
  yield takeLatest(COURSE_LIST_GET._REQUEST, courselistGet);
}

function* modulelistGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      is_module: true,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getCoursesList,
      completeFilters
    );
    yield put({
      type: MODULE_LIST_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > modulelistGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* modulelistGetWatch() {
  yield takeLatest(MODULE_LIST_GET._REQUEST, modulelistGet);
}

function* eventlistGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      typology: 'event',
      approval_status: 'APPROVED',
      is_module: false,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getCoursesList,
      completeFilters
    );
    yield put({
      type: EVENT_LIST_GET._SUCCESS,
      data,
      pager,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > eventlistGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* eventlistGetGetWatch() {
  yield takeLatest(EVENT_LIST_GET._REQUEST, eventlistGet);
}

function* catalogsGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response = {} } = {} } = yield call(
      courselist.catalogsGet
    );

    yield put({ type: CATALOGS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > catalogsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* catalogsGetWatch() {
  yield takeLatest(CATALOGS_GET._REQUEST, catalogsGet);
}

function* categoriesGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response = {} } = {} } = yield call(
      courselist.getCategories,
      filters
    );

    yield put({
      type: COURSE_CATEGORIES_GET._SUCCESS,
      response,
      filters,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > categoriesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* categoriesGetWatch() {
  yield takeEvery(COURSE_CATEGORIES_GET._REQUEST, categoriesGet);
}

function* globalCategoriesGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response = {} } = {} } = yield call(
      courselist.globalCategoriesGet
    );

    yield put({
      type: GLOBAL_COURSE_CATEGORIES_GET._SUCCESS,
      response,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > globalCategoriesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* globalCategoriesGetWatch() {
  yield takeLatest(GLOBAL_COURSE_CATEGORIES_GET._REQUEST, globalCategoriesGet);
}

function* levelsGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response = {} } = {} } = yield call(
      courselist.levelsGet
    );

    yield put({ type: LEVELS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > levelsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* levelsGetWatch() {
  yield takeLatest(LEVELS_GET._REQUEST, levelsGet);
}

function* ffooGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response = {} } = {} } = yield call(
      courselist.ffooGet
    );

    yield put({ type: FFOO_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > ffooGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* ffooGetWatch() {
  yield takeLatest(FFOO_GET._REQUEST, ffooGet);
}

function* globalCourselistGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(
      courselist.getGlobalCoursesList,
      completeFilters
    );
    yield put({
      type: GLOBAL_COURSE_LIST_GET._SUCCESS,
      data,
      pager,
      isModule: filters?.is_module,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > globalCourselistGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* globalCourselistGetWatch() {
  yield takeEvery(GLOBAL_COURSE_LIST_GET._REQUEST, globalCourselistGet);
}

function* globalCourselistExport({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const err = yield call(courselist.globalCoursesListExport, completeFilters);
    if (err?.message) throw Error(err);
    else {
      yield put({ type: GLOBAL_COURSE_LIST_EXPORT._SUCCESS });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > courselist > globalCourselistExport', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* globalCourselistExportWatch() {
  yield takeLatest(GLOBAL_COURSE_LIST_EXPORT._REQUEST, globalCourselistExport);
}

export default [
  courselistGetWatch(),
  modulelistGetWatch(),
  eventlistGetGetWatch(),
  catalogsGetWatch(),
  categoriesGetWatch(),
  globalCategoriesGetWatch(),
  levelsGetWatch(),
  ffooGetWatch(),
  globalCourselistGetWatch(),
  globalCourselistExportWatch(),
];
